import React from 'react'
import './styles.css'

const BlockTitle = ({ children }) => children ? (
  <div className="BlockTitle site-color">{children}</div>
) : <div/>

export default BlockTitle;